module.exports = __webpack_public_path__ + "static/img/RIC.024083c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/RIC.svg
// module id = v4uv
// module chunks = 1